
import Vue from 'vue'
export default Vue.extend({
  props: {
    value: Boolean,
    app: Boolean,
    temporary: Boolean,
  },
  methods: {
    onInput(value: boolean) {
      this.$emit('input', value)
    },
  },
})
